<ng-container *ngIf="dataDownload">
	<app-banner-internal [title]="dataDownload.page_title"></app-banner-internal>

	<div class="container align-middle">
		<div class="body1" [innerHTML]="dataDownload.text"></div>
	</div>

	<app-list-of-products [data]="dataDownload"></app-list-of-products>

	<div style="height: 150px"></div>
</ng-container>

<div *ngIf="pageNotFound" class="container align-middle">
	<div class="body1">Conteúdo não encontrado.</div>
</div>
